module.exports = __webpack_public_path__ + "static/img/gouWuJie_start.c90944e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newVcard/gouWuJie_start.png
// module id = 1MZp
// module chunks = 1